<script setup lang="ts">
import { ElNotification } from 'element-plus'
import { confirmedEmail } from '@/components/goat/page/home/RegisterBox'
import { ModeEnum } from '@/types/enums'

const { t } = useI18n()
const { updateMode } = siteUtils

const loading = ref(false)
function onSubmitConfirmEmail(data: FormTypes.SubmitForm) {
  loading.value = true
  const { getGoatApiUrl } = siteUtils
  const { getAxiosInstance, catchFormErrors } = appUtilsPlugin
  ElNotification.closeAll()
  getAxiosInstance()
    ?.post(getGoatApiUrl('confirm-email'), { ...data.form, email: confirmedEmail.value || '' })
    .then((response) => {
      switch (response?.data?.status || '') {
        case 'ok':
        { ElNotification({
          title: t('confirmEmail.notify.confirmed.title'),
          message: t('confirmEmail.notify.confirmed.message'),
          type: 'success',
          duration: 9000,
          offset: 100,
          appendTo: '#auth-wrapper',
          customClass: 'right-1/2 translate-x-1/2 large absolute'
        })
        const { gaSignUpMethods, gaSignUp, gaSections, contextGaRef } = gaUtils
        gaSignUp({
          method: `${gaSignUpMethods.goatForm}`,
          gs_section: contextGaRef.value?.gs_section || gaSections.registerForm,
          gs_context: `${contextGaRef.value?.gs_context || ''}${contextGaRef.value?.gs_context?.length ? ',' : ''}${response?.data?.acceptCommunication ? 'acceptCommunication=true' : 'acceptCommunication=false'}`,
          gs_user_id: response?.data?.id ? `goat_${response?.data?.id}` : ''
        })
        confirmedEmail.value = ''
        updateMode(ModeEnum.login)
        break }
        case 'invalid_token':
          ElNotification({
            title: t('confirmEmail.notify.invalidToken.title'),
            type: 'error',
            duration: 9000,
            offset: 100,
            appendTo: '#auth-wrapper',
            customClass: 'right-1/2 translate-x-1/2 large absolute'
          })
          break
        default:
          ElNotification({
            title: t('confirmEmail.notify.unavailable.title'),
            message: t('confirmEmail.notify.unavailable.message'),
            type: 'error',
            duration: 9000,
            offset: 100,
            appendTo: '#auth-wrapper',
            customClass: 'right-1/2 translate-x-1/2 large absolute'
          })
      }
    })
    .catch(catchFormErrors(data.externalErrors, { appendTo: '#auth-wrapper' }))
    .then(() => {
      loading.value = false
    })
}
</script>

<template>
  <div class="box-form-wrapper mx-auto max-w-2xl big:max-w-(--breakpoint-xl) big:px-16 mt-5">
    <div
      class="box-form big:mt-10 mx-3 bg-white pt-10 big:pt-16 pb-10 px-2 big:px-16 rounded-2xl flex flex-col items-center"
    >
      <div class="mx-auto w-full max-w-md">
        <h1 class="text-lg big:text-2xl uppercase font-semibold text-center tracking-wider ">
          {{ t('confirmEmail.title') }}
        </h1>
        <goat-form-component
          class="mt-6 big:mb-5 w-full"
          size="large"
          hide-required-asterisk
          @submit="onSubmitConfirmEmail"
        >
          <template #default="{ submit, form }">
            <goat-form-field-text-trim
              api-field-name="token"
              :placeholder="t('form.verificationCode')"
              :label="!!form?.token?.length ? t('form.verificationCode') : false"
              class="mt-1 big:mt-1.5 text-lg"
              required
              maxlength="4"
              show-word-limit
              :rules="[{ type: 'string', trigger: 'change', len: 4, message: t('form.validation.fourCharsRequired') }]"
              @keyup.enter.stop.prevent="submit"
            />
            <goat-form-fields-group>
              <div class="mb-6 px-2">
                {{ t('confirmEmail.description') }}
              </div>
            </goat-form-fields-group>
            <goat-form-fields-group
              justify="space-between"
            >
              <el-button
                type="info"
                class="text-white rounded-lg uppercase text-lg w-[46%]"
                @click="updateMode(ModeEnum.register)"
              >
                {{ t('confirmEmail.cancelBtn') }}
              </el-button>
              <el-button
                color="#29b300"
                class="text-white rounded-lg uppercase text-lg w-[46%]"
                size="large"
                :loading="loading"
                @click="submit()"
              >
                {{ t('confirmEmail.confirmBtn') }}
              </el-button>
            </goat-form-fields-group>
          </template>
        </goat-form-component>
      </div>
    </div>
  </div>
</template>

<style scoped lang="postcss">

</style>
